export var errorCodes = ['404'];
